import {Action, Dispatch} from 'redux';
import {SPECIAL_WALLETS_URL} from '@crema/services/ApiConfig';
import {showError, showMessage, showWarning} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {
  FETCH_SPECIAL_WALLETS,
  FETCH_SPECIAL_WALLETS_SUCCESS,
  FETCH_SPECIAL_WALLETS_ERROR,
  SpecialWalletsActions,
  EXECUTE_SPECIAL_WALLET_TRANSACTION,
  EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS,
  EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR,
} from '../../types/actions/SpecialWallets.actions';
import {ISpecialWallet} from '../../types/models/SpecialWallet';
import {logger} from '../../shared/logger';

export const fetchSpecialWallets =
  () => (dispatch: Dispatch<ApiActionCall | SpecialWalletsActions>) => {
    dispatch({type: FETCH_SPECIAL_WALLETS});

    const onSuccess = (payload: any) => (dispatch: Dispatch<Action>) => {
      if (payload?.status === 204) {
        dispatch(showWarning('Currently no exchange services available.'));
      }

      dispatch({
        type: FETCH_SPECIAL_WALLETS_SUCCESS,
        payload: Array.isArray(payload) ? payload : [],
      });
    };

    const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
      logger.error(message);
      dispatch({type: FETCH_SPECIAL_WALLETS_ERROR});
      dispatch(showError('Failed to fetch special wallet list.'));
    };
    dispatch({
      type: ApiActionTypes.API_CALL,
      payload: {
        url: SPECIAL_WALLETS_URL,
        method: 'GET',
        label: 'Fetch special wallets',
        onSuccess,
        onFailure,
      },
    });
  };

export const executeSpecialWalletTransaction =
  (amount: string, specialWalletId: string, success: boolean) =>
  async (dispatch: Dispatch<ApiActionCall | SpecialWalletsActions>) => {
    dispatch({type: EXECUTE_SPECIAL_WALLET_TRANSACTION});

    const onSuccess = (payload: any) => (dispatch: Dispatch<Action>) => {
      if (payload?.status === 204) {
        dispatch(showWarning('Currently no exchange services available.'));
      }
      dispatch({type: EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS, payload});
    };

    const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
      dispatch({type: EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR});
      dispatch(showError(message || 'Failed to perform transaction'));
    };

    dispatch({
      type: ApiActionTypes.API_CALL,
      payload: {
        url: SPECIAL_WALLETS_URL,
        method: 'POST',
        data: {
          amount,
          specialWalletId: specialWalletId,
          success,
        },
        label: 'Execute special wallets transaction',
        onSuccess,
        onFailure,
      },
    });
  };
